export const ContinuousProcType = ['CVVHD', 'CVVHDF']

export const PeritonealProcType = [
  'DPA',
  'DPAC',
  'DPAP (PEDIATRIA)',
  'DPI',
  'DIÁLISE PERITONIAL DOMICILIAR'
]
